<template>
  <div class="Contato mb-2">
    <div class="Contato_header mb-2">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="Contato_header_title">
            Contato
          </h2>
        </div>
      </div>
    </div>
    <div class="mb-3 pl-2 pr-2">
      <div class="row">
        <div class="col-3">
          <label class="label"
                 :for="`contato_telefone_1_${ _uid }`">Telefone 1</label>
          <input v-model="contato.telefone_1"
                 v-mask="'(99) 999999999'"
                 type="text"
                 class="form-control form-control-sm"
                 @change="change()">
        </div>
        <div class="col-3">
          <label class="label"
                 :for="`contato_telefone_2_${ _uid }`">Telefone 2</label>
          <input v-model="contato.telefone_2"
                 v-mask="'(99) 999999999'"
                 type="text"
                 class="form-control form-control-sm"
                 @change="change()">
        </div>
        <div class="col-3"
             style="display: none">
          <label class="label"
                 :for="`contato_email_${ _uid }`">E-mail</label>
          <input v-model="contato.email"
                 type="text"
                 class="form-control form-control-sm"
                 @change="change()">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Contato",
    props: {
      propContato: {
        type: Object,
        default: () => ({})
      },
      propPessoa: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        contato: {
          telefone_1: null,
          telefone_2: null,
          email: null
        }
      }
    },
    watch: {
      propContato () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.contato = { ...this.propContato }
      },
      change () {
        this.$emit('onChange', this.contato)
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .Contato {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;
      color: #000;

      &_error {
        color: #8B0000
      }

      &_title {
        @extend %titleBox_title;
      }
    }
  }
</style>
